'use strict'

import ApiClient from './ApiClient'

export default class DisplaySettingRepository {
  /**
   * TOPページの名刺表示件数設定を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/dcsettings`)
  }

  /**
   * TOPページの名刺表示件数設定を更新
   * @param params sendData
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/dcsettings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/DisplaySettingRepository.js